import {
  ButtonPrimeReact,
  DropdownPrimeReact,
  PrimeReactModal,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TIPO_FACTURA_RECTIFICATIVA_ENUM } from "api/DTOs/TipoFacturaRectificativa"
import { useEnumCodigoFacturaRectificativa } from "api/Enum.hook"
import { MODAL_STYLES } from "constants/primereactStyles"
import { InputTextarea } from "primereact/inputtextarea"
import { useTranslation } from "react-i18next"
import { FormikDocumentsProps } from "../../CreacionDocumento"

const ModalJustificarFacturaRectificativa = ({
  values,
  setFieldValue,
  handleSubmit,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const { codigoFacturaRectificativa } = useEnumCodigoFacturaRectificativa()
  const getTipoFacturaRectificativaOptions = (t: (key: string) => string) => [
    {
      value: TIPO_FACTURA_RECTIFICATIVA_ENUM.SUSTITUTIVA,
      label: t("newDoc.facturarRectifitiva.modal.firstDropdownOptioon"),
    },
  ]
  const isNotFilledAllFields =
    !values.facturaRectificativa?.tipoFacturaRectificativa ||
    !values.facturaRectificativa?.motivo ||
    !values.facturaRectificativa?.codigoRectificativa

  return (
    <PrimeReactModal
      visible={values?.modals?.showModalSubmitRectificativa}
      className='tw-w-112 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={40}
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-flex tw-justify-between tw-items-center tw-mb-6 tw-h-10'>
          <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
            {t("newDoc.facturarRectifitiva.modal.title")}
          </p>
          <ButtonPrimeReact
            className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
            onClick={() => {
              setFieldValue("modals.showModalSubmitRectificativa", false)
              setFieldValue(
                "facturaRectificativa.codigoRectificativa",
                undefined
              )
              setFieldValue(
                "facturaRectificativa.tipoFacturaRectificativa",
                undefined
              )
              setFieldValue("facturaRectificativa.motivo", undefined)
            }}
          >
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              className='tw-w-5 tw-h-5'
            />
          </ButtonPrimeReact>
        </div>
      }
      footer={
        <div className='tw-flex tw-flex-row tw-justify-end tw-items-center tw-pt-6'>
          <ButtonPrimeReact
            onClick={() => {
              setFieldValue("modals.showModalSubmitRectificativa", false)
              setFieldValue(
                "facturaRectificativa.codigoRectificativa",
                undefined
              )
              setFieldValue(
                "facturaRectificativa.tipoFacturaRectificativa",
                undefined
              )
              setFieldValue("facturaRectificativa.motivo", undefined)
            }}
            className='!tw-h-12 !tw-px-4 !tw-flex !tw-justify-center !tw-items-center !tw-border-transparent !tw-bg-transparent !tw-text-primary !tw-rounded'
          >
            {t("newDoc.facturarRectifitiva.modal.cancelButton")}
          </ButtonPrimeReact>
          <ButtonPrimeReact
            disabled={isNotFilledAllFields}
            onClick={() => {
              handleSubmit && handleSubmit()
              setFieldValue("modals.showModalSubmitRectificativa", false)
            }}
            className={`!tw-h-12 !tw-px-4 !tw-flex !tw-justify-center !tw-items-center !tw-border-primary !tw-bg-primary !tw-text-white !tw-rounded !tw-ml-4 ${
              isNotFilledAllFields ? "tw-opacity-70" : ""
            }`}
          >
            {t("newDoc.facturarRectifitiva.modal.applyButton")}
          </ButtonPrimeReact>
        </div>
      }
    >
      <div className='tw-text-text-50 tw-mb-3'>
        <label
          htmlFor='dropdown-tipoFacturaRectificativa'
          className='tw-block tw-mb-2'
        >
          {t("newDoc.facturarRectifitiva.modal.labelCorrectionType")}
        </label>
        <DropdownPrimeReact
          placeholder={`${t("newDoc.facturarRectifitiva.modal.placeholder")}`}
          options={getTipoFacturaRectificativaOptions(t)}
          onChange={({ value }: { value: string }) => {
            setFieldValue(
              "facturaRectificativa.tipoFacturaRectificativa",
              value
            )
          }}
          value={values.facturaRectificativa?.tipoFacturaRectificativa}
          key='dropdown-tipoFacturaRectificativa'
          optionLabel='label'
          optionValue='value'
        />
      </div>
      <div className='tw-text-text-50 tw-mb-3'>
        <label
          htmlFor='dropdown-tipoRectificativa'
          className='tw-block tw-mb-2'
        >
          {t("newDoc.facturarRectifitiva.modal.labelDropdownTwo")}
        </label>
        <DropdownPrimeReact
          placeholder={`${t(
            "newDoc.facturarRectifitiva.modal.placeholderTwo"
          )}`}
          options={codigoFacturaRectificativa}
          onChange={({ value }: { value: string }) => {
            setFieldValue("facturaRectificativa.codigoRectificativa", value)
          }}
          value={values.facturaRectificativa?.codigoRectificativa}
          key='dropdown-tipoRectificativa'
          optionLabel='description'
          optionValue='id'
        />
      </div>
      <div className='tw-text-text-50'>
        <label
          htmlFor='textarea-tipoFacturaRectificativa'
          className='tw-block tw-mb-2'
        >
          {t("newDoc.facturarRectifitiva.modal.labelReason")}
        </label>
        <InputTextarea
          rows={5}
          cols={10}
          autoResize
          className='tw-w-full'
          id='textarea-tipoFacturaRectificativa'
          name='textarea-tipoFacturaRectificativa'
          value={values.facturaRectificativa?.motivo}
          onChange={(e) => {
            setFieldValue("facturaRectificativa.motivo", e.target.value)
          }}
          autoComplete='off'
        />
      </div>
    </PrimeReactModal>
  )
}

export default ModalJustificarFacturaRectificativa
